import {Suspense, useMemo, useState} from "react";
import ClubHeader from "./components/header";
import ClubActivities from "./components/activities";
import ClubMyActivities from "./components/my-activities";
import useQueryString from "../../core/hooks/useQueryString";
import TabView from "../../core/components/tab-view";
import RenderIf from "../../core/components/render-if";
import {MiniLoading} from "../../core/components/loading";
import MainLayout from "../../layout/mainLayout/mainLayout";
import {useAuthContext} from "../Auth/provider/AuthProvider";
import ProfileNotCompleteModal from "../../core/components/modal/profile-not-complete";

const ClubPage = () => {
    const {queryStringFN} = useQueryString();
    const {user} = useAuthContext()
    const [modal, setModal] = useState(!user?.firstName ? "profile-not-complete" : "idle");
    // const { complete } = useUser();

    const memoTabs = useMemo(() => {
        const temp = [
            {id: "activities", title: 'دوره‌ها'},
            {id: "my-activities", title: 'دوره‌های من'},
        ];
        return temp;
    }, []);

    const getActiveIndex = () => {
        return queryStringFN.get("view");
    };

    const handleChangeTab = (tab) => {
        queryStringFN.set("view", tab.id);
    };

    // if (complete === "failed") return <Navigate to={ROUTES.ERROR(403)} replace />;

    return (
        <>
            <MainLayout>
                <ProfileNotCompleteModal isOpen={modal === "profile-not-complete"} onClose={() => setModal("idle")}/>
                <ClubHeader/>
                <TabView tabs={memoTabs} activeTab={getActiveIndex()} onClick={handleChangeTab} className="pb-40">
                    <Suspense fallback={<MiniLoading/>}>
                        <RenderIf cond={queryStringFN.get("view", "activities") === "activities"}>
                            <ClubActivities/>
                        </RenderIf>
                        <RenderIf cond={queryStringFN.get("view") === "my-activities"}>
                            <ClubMyActivities/>
                        </RenderIf>
                    </Suspense>
                </TabView>
            </MainLayout>
        </>
    );
};

export default ClubPage;
